import type { ReactNode } from 'react';
import {
  CalendarIcon,
  DownloadSimpleIcon,
  LinkIcon,
  PaperPlaneTiltIcon,
  PhoneIcon,
} from '@phosphor-icons/react';

// Per design (MED-6836), only the "known" link types get a custom icon
// (calendar / email / phone / url / document download) — any other
// (future) type falls back to the generic link icon, and no CTA is
// ever skipped just for lacking a custom icon.
const KNOWN_CTA_ICON_BY_TYPE: Record<string, ReactNode> = {
  Email: <PaperPlaneTiltIcon size={14} />,
  CalendarAppointment: <CalendarIcon size={14} />,
  Phone: <PhoneIcon size={14} />,
  ExternalLink: <LinkIcon size={14} />,
  DocumentDownload: <DownloadSimpleIcon size={14} />,
};
const DEFAULT_CTA_ICON = <LinkIcon size={14} />;

export const getCallToActionIcon = (actionType: string): ReactNode =>
  KNOWN_CTA_ICON_BY_TYPE[actionType] ?? DEFAULT_CTA_ICON;

// Fallback label (used when a CTA has no label defined for the current
// locale) per CTA action type; anything without a specific entry falls
// back to the generic "learn more" wording.
const CTA_FALLBACK_LABEL_KEY: Record<string, string> = {
  Email: 'experienceV2.document.actions.contactSender',
  CalendarAppointment: 'experienceV2.document.actions.bookMeeting',
  DocumentDownload: 'experienceV2.document.actions.save',
  Phone: 'experienceV2.document.actions.callUs',
};
const DEFAULT_CTA_FALLBACK_LABEL_KEY = 'experienceV2.document.actions.learnMore';

export const getCallToActionFallbackLabelKey = (actionType: string): string =>
  CTA_FALLBACK_LABEL_KEY[actionType] ?? DEFAULT_CTA_FALLBACK_LABEL_KEY;
